import React, { useEffect } from "react";
// @ts-ignore
import confetti from "canvas-confetti";

export default function Confetti() {
  useEffect(() => {
    const end = Date.now() + 0.5 * 1000;

    // go Buckeyes!
    const colors = ["#cc9600", "#ffffff"];

    const commonVars = {
      particleCount: 2,
      spread: 55,
      colors,
      zIndex: 10000,
      disableForReducedMotion: true,
    };

    (function frame() {
      confetti({
        angle: 60,
        origin: { x: 0 },
        ...commonVars,
      });
      confetti({
        angle: 120,
        origin: { x: 1 },
        ...commonVars,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }, []);

  return <></>;
}
